import * as Sentry from '@sentry/capacitor'

import { useIsNative } from '~/composables/usePlatform'

// This plugin must be registered AFTER sentry.client.ts
export default defineNuxtPlugin(_nuxtApp => {
  const config = useRuntimeConfig()
  const isNative = useIsNative()

  // Only initialize in native environment
  if (isNative) {
    try {
      Sentry.init({
        dsn: config.public.sentry.dsn,
        environment: config.public.sentry.environment,
        enableSessionTracking: true,
        enableNativeCrashHandling: true,
      })

      return {
        provide: {
          sentry: Sentry,
        },
      }
    } catch (error) {
      console.error('Error initializing Sentry Capacitor:', error)
    }
  }

  // Return empty object in web environment
  return {}
})

declare module '#app' {
  interface NuxtApp {
    $sentry: typeof Sentry
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $sentry: typeof Sentry
  }
}
